import React from "react";
import CreditProduct from "./CreditProduct";
import withHOC from "../../HOC/HOC";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { supplierSearchFilterForParticularMinimartAction } from "../SupplierCatalog/SupplierCatalogAction";
import { OPERATION_STATUS } from "../../config/axios.init";
import { getDropdownValuesForSupplierFormAction, getEmiDurationAction, getFrequencyConfigurationAction, getPossibleCollectionCycleAction, getTermsAndrateAction } from "../AnalystApproval/AnalystApprovalAction";
import { bankDetailsSearchFilter } from "../BankConf/BankConfAction";
import { FREQUENCIES } from "../LoanDetails/Constants";
import Utility from "../../utils/Utility";
import { createLoanAction, setApplyLoanConfigAction, setCreditProductInputDataForEditAction, setCreditProductValuesAction } from "../CreateLoan/CreateLoanAction";
import { LOAN_TYPES } from "../AnalystApproval/Constants";
import { Row } from "react-bootstrap";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";
import { Strings } from "../../resources/i18n/i18n";
import { LOAN_APPLICATION_STATUS } from "../../constants/appConstants";
class CreditProductContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      businessNameList: [],
      disbursementTypeList: [],
      transferAccountTypeList: [],
      bankDetails: [],
      frequencyList: [],
      termsArray: [],
      currentCollectionCycle: [],
      possibleCollectionDays: [],
      calculatedEMIData: {},
      toShowToast: false,
      successToastMessage: "",
      level: "",
    };
  }
  getSupplierDetails = () => {
    this.props.showLoadingModal()
    supplierSearchFilterForParticularMinimartAction(
      {
        mid: this.props.singleMiniMart.id,
        ia: true,
      },
      (response) => {
        if (response.status === OPERATION_STATUS.SUCCESS) {
          const supplierList = response.data.data.li.map((item) => ({
            name: item.businessName,
            value: item.businessName,
            supplierId: item.supplierId
          }));
          this.setState({
            businessNameList: supplierList,
            errorMessage: "",
          });
          this.props.closeLoadingModal()
        } else {
          this.setState({
            errorMessage: response.error.message,
            businessNameList: [],
          });
          this.props.closeLoadingModal()

        }
      }
    );
  };
  calculateEMICall = (requestData) => {
    this.props.showLoadingModal()
    getEmiDurationAction(requestData, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState({
          showLoadingModal: false,
          calculatedEMIData: response.data.data,
          errorMessage: "",
        }, () => {
          this.props.closeLoadingModal()

        });
      } else {
        this.setState({
          showLoadingModal: false,
          errorMessage: response.error.message,
        }, () => {
          this.props.closeLoadingModal()
        })
      }
    })
  }
  getDropdownValuesForSupplierForm = () => {
    this.props.showLoadingModal()
    getDropdownValuesForSupplierFormAction((response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        const supplierDropdownValues = [];
        const accountTypes = [];
        response.data.data.forEach((item) => {
          supplierDropdownValues.push({
            name: item.disbursementType,
            value: item.disbursementType,
          });

          if (Array.isArray(item.accountTypes)) {
            item.accountTypes.forEach((accountType) => {
              if (!accountTypes.includes(accountType)) {
                accountTypes.push(accountType);
              }
            });
          }
        });

        this.setState(
          {
            disbursementTypeList: supplierDropdownValues,
            transferAccountTypeList: accountTypes,
          });
        this.props.closeLoadingModal()

      } else {
        this.setState({
          errorMessage: response.error.message,
        });
        this.props.closeLoadingModal()

      }
    });
  };
  getBankDetails = () => {
    this.props.showLoadingModal()
    bankDetailsSearchFilter({}, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState(
          {
            showLoadingModal: false,
            bankDetails: response.data.data.li,
          });
        this.props.closeLoadingModal()
      } else {
        this.setState({
          showLoadingModal: false,
          errorMessage: response.error.message,
        });
        this.props.closeLoadingModal()
      }
    });
  };
  getFrequencyList = (request) => {
    this.props.showLoadingModal()
    getFrequencyConfigurationAction(request, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState(prevState => ({
          errorMessage: "",
          frequencyList: response.data.data.frqs,
        }), () => {
          this.props.closeLoadingModal()
        });
      } else {
        this.setState({
          errorMessage: response.error.message,
        }, () => {
          this.props.closeLoadingModal()
        });
      }
    });
  };
  assignTermsAndrateAction = (calculationData) => {
    const requestData = {
      loanType: this.props.selectedLoanType,
      amount: calculationData["amount"],
      frequency: calculationData["frequency"]
    }
    if (requestData.frequency !== "") {
      this.getTermsAndrate(requestData);
    }
  }
  setTermsArray = (terms) => {
    let termArray = [];
    if (terms !== null) {
      termArray = terms?.map((term) => term.term)
    }
    this.setState({
      termsArray: termArray
    })
  }
  getTermsAndrate = (request) => {
    this.props.showLoadingModal()
    getTermsAndrateAction(request, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState(
          {
            errorMessage: "",
          },
          () => {
            this.props.closeLoadingModal()
            this.setTermsArray(response.data.data.td)
          }
        );
      } else {
        this.setState({
          errorMessage: response.error.message,
          showLoadingModal: false,
        });
        this.props.closeLoadingModal()
      }
    });
  };
  getPossibleCollectionCycles = (req) => {
    this.setState({ showLoadingModal: true });
    let request = req;
    request["mid"] = this.props.singleMiniMartDetails.minimartDetails.id;
    if (request.fr !== FREQUENCIES.WEEKLY_THRICE && !this.props.isHistory) {
      request["frs"] = "LOAN_CREATION"
    }
    getPossibleCollectionCycleAction(request, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        let possibleCollectionDays = Utility.convertCollectionDaysToSpanishForDropdown(response.data.data.possibleCollectionDays)
        this.setState({
          showLoadingModal: false,
          possibleCollectionDays,
          currentCollectionCycle: response.data.data.minimartCollectionCycle,
          errorMessage: "",
        });
      } else {
        this.setState({
          showLoadingModal: false,
          errorMessage: response.error.message,
        });
      }
    });
  }
  createLoanCall = (requestData, creditProductValues, callback) => {
    this.props.showLoadingModal()
    createLoanAction(requestData, (response) => {
      if (response.status === OPERATION_STATUS.SUCCESS) {
        this.setState(
          {
            errorMessage: "",
            toShowToast: true,
            successToastMessage: Strings("loanCreatedSuccessfully"),
            level: "success",
          }, () => {
            let applyLoanConfig = {
              loanApplicationId: response.data.data.loanApplicationId,
              minimartCode: this.props.singleMiniMartDetails.minimartDetails.id,
              type: this.props.selectedLoanType,
              updateConsumerLoan: true,
            }
            setTimeout(() => {
              this.props.handleNext();
              this.props.setApplyLoanConfigAction(applyLoanConfig);
              this.props.setCreditProductValuesAction(creditProductValues)
              this.props.setCreditProductInputDataForEditAction(creditProductValues);
              callback("");
              this.props.closeLoadingModal();
            }, 1000);
          }
        );
      } else {
        this.props.closeLoadingModal();
        callback(response.error.message);
      }
    })
  }
  render() {
    return (
      <Row>
        {this.state.toShowToast && (
          <UserNotification
            key={this.state.successToastMessage}
            userNotificationObj={{
              message: this.state.successToastMessage,
              level: this.state.level,
            }}
          />
        )}
        <CreditProduct
          getSupplierDetails={this.getSupplierDetails}
          selectedLoanType={this.props.selectedLoanType}
          businessNameList={this.state.businessNameList}
          getDropdownValuesForSupplierForm={this.getDropdownValuesForSupplierForm}
          transferAccountTypeList={this.state.transferAccountTypeList}
          disbursementTypeList={this.state.disbursementTypeList}
          getBankDetails={this.getBankDetails}
          bankDetails={this.state.bankDetails}
          errorMessage={this.state.errorMessage}
          getFrequencyList={this.getFrequencyList}
          minimartDetails={this.props.singleMiniMartDetails}
          assignTermsAndrateAction={this.assignTermsAndrateAction}
          getPossibleCollectionCycles={this.getPossibleCollectionCycles}
          calculateEMICall={this.calculateEMICall}
          calculatedEMIData={this.state.calculatedEMIData}
          EMIAmount={this.props.EMIAmount}
          selectedRecordData={this.props.selectedRecordData}
          createLoan={this.createLoanCall}
          existingLoanDetails={this.props.existingLoanDetails}
          selectedRecordDetails={this.props.selectedRecordDetails}
          loanApplicationDetails={this.props.allLoanDetails}
          suggestedAmount={this.props.suggestedAmount}
          showLoadingModal={this.props.showLoadingModal}
          closeLoadingModal={this.props.closeLoadingModal}
          getLastDisbursedLoanId={this.props.getLastDisbursedLoanId}
          termsArray={this.state.termsArray}
          collectionDaysList={this.state.possibleCollectionDays}
          frequencyList={this.state.frequencyList}
          setCreditProductValues={this.setCreditProductValues}
          creditProductDetails={this.props.creditProductDetails}
          activeStep={this.props.activeStep}
          goBack={this.props.handleBack}
          goNext={this.props.handleNext}
          existingLoanCreatedInvoice={this.props.existingLoanCreatedInvoice}
          getLoanApplicationDetails={this.props.getLoanApplicationDetails}
          loanInfo={this.props.loanInfo}
          disableTextField={this.props.disableTextField}
          applyLoanConfig={this.props.applyLoanConfig}
          basicInfo={this.props.basicInfo}
          isDisbursed={this.props.existingLoanDetails?.st === LOAN_APPLICATION_STATUS.disbursed}
          hasExistingLoan={this.props.existingLoanDetails !== null || (this.props.selectedLoanType === LOAN_TYPES.FACTORING && this.props.applyLoanConfig?.loanStatus !== LOAN_APPLICATION_STATUS.disbursed)}
          creditProductInputDataForEdit={this.props.creditProductInputDataForEdit}
          showLoadingModalState={this.props.showLoadingModalState}
        />
      </Row>
    )
  }
}
const mapStateToProps = (state) => ({
  loanInfo: state.loanDetailsReducer.loanInfo,
  singleMiniMart: state.minimartListReducer.singleMiniMart,
  singleMiniMartDetails: state.minimartListReducer.singleMiniMartDetails,
  allLoanDetails: state.loanDetailsReducer.allLoanDetails,
  creditProductDetails: state.loanDetailsReducer.creditProductDetails,
  applyLoanConfig: state.loanDetailsReducer.applyLoanConfig,
  basicInfo: state.loanDetailsReducer.basicInfo,
  creditProductInputDataForEdit: state.loanDetailsReducer.creditProductInputDataForEdit,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setCreditProductValuesAction,
      setApplyLoanConfigAction,
      setCreditProductInputDataForEditAction,
    },
    dispatch
  );
};

const CreditProductContainerWrapper = withHOC(CreditProductContainer);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreditProductContainerWrapper);